import { Modal } from "antd";
import * as React from "react";

export const RenderModalResetPassword = ((props:{isOpen?: boolean, onOk?:()=>void, onCancel?:()=>void, fullName?: string, id?:number})=>{
    return(
        <Modal
            title="Reset Password"
            centered
            open={props.isOpen}
            onOk={() => props.onOk()}
            onCancel={() =>props.onCancel()}
        >
            <p>Are you sure want to reset password for {props.fullName}, Account # {props.id}</p>
        </Modal>
    )
})